import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';
import assignments from './reducers/assignments';
import modelSelectionReducer from './reducers/modelSelection';
import peerReviewReducer from './reducers/peerReview';
import projectsReducer from './reducers/projects';
import refDocReducer from './reducers/refDoc';
import userReducer from './reducers/users';
import pronounsReducer from './reducers/pronouns';
import modelAssessmentReducer from './reducers/modelAssessment';
import authReducer from './reducers/auth';

export const makeStore = () => configureStore({
  reducer: {
    refDocReducer,
    modelSelectionReducer,
    peerReviewReducer,
    assignments,
    projectsReducer,
    userReducer,
    pronounsReducer,
    modelAssessmentReducer,
    authReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware(),
  // .prepend(listenerMiddleware.middleware) // TODO: DOING: Find way to fix type so hooks don't break
});

export type AppStore = ReturnType<typeof makeStore>;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];
export type AppThunk = ThunkAction<void, RootState, unknown, Action>;
